export default __webpack_public_path__ + "static/planet-c00d6c697194d23b1e006f1de1173bd6.png";